module.exports = __webpack_public_path__ + "static/media/iot.133104f4.svg";